angular.module('satv.playlist.pitch')
.controller('PitchNoteCtrl', function($scope, PitchNoteLoader, PitchNoteModal) {

    $scope.init = function(pitch) {

        $scope.notesLoader = new PitchNoteLoader({
            pitch: pitch.hash
        }).getFirstPage();

    };

    $scope.create = function(pitch) {
        PitchNoteModal.open({
            success: function(r) {
                $scope.notesLoader.getAll();
            }
        }, {
            pitch: pitch
        });
    };

    $scope.edit = function(pitch, note) {
        PitchNoteModal.open({
            success: function() {
                $scope.notesLoader.getAll();
            }
        }, {
            pitch: pitch,
            model: angular.copy(note)
        });
    };
});



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistpitchclientbundle/Resources/js/angular/controllers/PitchNoteCtrl.js